import request from "./../utils/request";

export const DRIVE_API = {
    listAllFolders: () => {
        console.log("[DRIVE] listAllFolders");
        return request.get("/drive/folders").then((response) => response.data);
    },

    listFilesByFolderId: (folderId) => {
        console.log(`[DRIVE] listFilesByFolderId: ${folderId}`);
        return request.get(`/drive/folders/${folderId}`).then((response) => response.data);
    },

    createFolder: (name, parentFolderId) => {
        console.log(`[DRIVE] createFolder: ${name} parentFolderId: ${parentFolderId}`);
        return request.post("/drive/folders", { name, parentFolderId }).then((response) => response.data);
    },

    updateFolderName: (folderId, name) => {
        console.log(`[DRIVE] updateFolderName: ${folderId} - ${name}`);
        return request.patch(`/drive/folders/${folderId}`, { name }).then((response) => response.data);
    },

    deleteFolder: (folderId) => {
        console.log(`[DRIVE] deleteFolder: ${folderId}`);
        return request.delete(`/drive/folders/${folderId}`).then((response) => response.data);
    },

    addAssetToFolder: (folderId, assetId) => {
        console.log(`[DRIVE] addAssetToFolder: ${folderId}`);
        return request.post(`/drive/folders/${folderId}/${assetId}/attach`).then((response) => response.data);
    },

    deleteFile: (folderId, fileId) => {
        console.log(`[DRIVE] deleteFile: ${folderId} - ${fileId}`);
        return request.delete(`/drive/folders/${folderId}/files/${fileId}`).then((response) => response.data);
    },

    removeMultiFiles: (folderId, fileIds) => {
        console.log(`[DRIVE] removeMultiFiles: ${folderId} - ${fileIds}`);
        return request
            .post(`/drive/folders/${folderId}/delete-multi-file`, {
                fileIds,
            })
            .then((response) => response.data);
    },
};
